import cx from 'classnames';
import * as _ from 'lodash';
import React from 'react';

import Button from '../../../generic/Button';
import type { Repository } from '../../../../types';

import BranchDropdown from './BranchDropdown';
import RowCheckbox from './RowCheckbox';
import RowTitle from './RowTitle';
import type { OnBranchChangeFn, OnImportRepositoryFn, OnSelectRepositoryFn } from './types';

import styles from './ProjectRowBase.module.less';

type ProjectRowBaseProps = {
  repo: Repository;
  selectedRepos: Repository[];
  onBranchChange: OnBranchChangeFn;
  onSelectRepository: OnSelectRepositoryFn;
  onImportRepository: OnImportRepositoryFn;
  status?: React.ReactNode;
  rowClassName?: string;
};

const ProjectRowBase = ({
  repo,
  selectedRepos,
  onBranchChange,
  onSelectRepository,
  onImportRepository,
  status,
  rowClassName,
}: ProjectRowBaseProps) => {
  const hasNoBranches = !repo.branches || _.isEmpty(repo.branches);
  const isSelected = !!selectedRepos.find(
    (selectedRepo: Repository) => selectedRepo.title === repo.title,
  );
  const rowClassNames = cx(styles.row, rowClassName, {
    [styles.selected]: isSelected,
    [styles.disabled]: hasNoBranches,
  });

  const onRowClick = () => {
    if (hasNoBranches) {
      return;
    }
    onSelectRepository(repo);
  };

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div
      className={rowClassNames}
      onClick={(e) => {
        // Opening the branch dropdown calls e.preventDefault(). We
        // catch that here to avoid selecting the current repository.
        if (e.defaultPrevented) {
          return;
        }
        onRowClick();
      }}
    >
      <RowCheckbox isSelected={isSelected} />
      <RowTitle repo={repo} />
      <BranchDropdown onBranchChange={onBranchChange} repo={repo} />
      {status && <span className={styles.status}>{status}</span>}
      <div>
        <Button
          testId="repo-action-import"
          onClick={(e) => {
            // Prevent selecting this row's checkbox when clicking the import button.
            e.stopPropagation();
            onImportRepository(repo);
          }}
        >
          Import
        </Button>
      </div>
    </div>
  );
};

export default ProjectRowBase;
